module.exports = __webpack_public_path__ + "static/media/minus.9cda28df.svg";